import React, { useEffect, useRef, useState } from 'react';
import './coperturaagenteanim.css';

/* Hero "Agente Copertura al lavoro" — SINCRONA con l'operazione reale.
   - running: radar in scansione ("interrogo la rete") sull'indirizzo corrente.
   - ad ogni record verificato (prop `flash` cambia) -> il badge con l'ESITO REALE
     (Coperto/Non coperto/Non censito/Errore) esce dal centro per ~1.6s.
   - standby/attesa: radar in pausa ("in attesa"). */

function SignalIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
      style={{ width: 34, height: 34, color: 'var(--accent)' }}>
      <path d="M4.5 11a11 11 0 0 1 15 0M7.5 14a7 7 0 0 1 9 0" /><circle cx="12" cy="18" r="1.6" fill="currentColor" stroke="none" />
    </svg>);
}

export default function CoperturaAgenteAnim({ attivo = true, standby = false, esito, flash }) {
  const [result, setResult] = useState(false);
  const firstFlash = useRef(true);

  useEffect(() => {
    if (flash == null) return undefined;
    if (firstFlash.current) { firstFlash.current = false; return undefined; }  // non lampeggiare al primo render
    setResult(true);
    const id = setTimeout(() => setResult(false), 1600);
    return () => clearTimeout(id);
  }, [flash]);

  const dim = !attivo || standby;
  const vc = esito?.color || 'var(--accent)';
  const label = esito?.label || 'VERIFICATO';

  return (
    <div className={`cpa${result ? ' ph3' : ''}${dim ? ' dim' : ''}`}>
      <div className="cpa-radar">
        <div className="cpa-orbit" />
        <div className="cpa-ring r1" /><div className="cpa-ring r2" /><div className="cpa-ring r3" />
        <div className="cpa-sat" />
        <div className="cpa-core"><SignalIcon /></div>
      </div>
      <div className="cpa-ov">
        <div className={`cpa-layer${(!result && attivo && !standby) ? ' on' : ''}`}>
          <div className="cpa-scan"><i /><i /><i /> interrogo la rete TIM</div>
        </div>
        <div className={`cpa-layer${(!result && dim) ? ' on' : ''}`}>
          <span className="cpa-lbl">{standby ? 'pausa anti-blocco…' : 'in attesa…'}</span>
        </div>
      </div>
      <div className={`cpa-verdict${result ? ' pop' : ''}`} style={{ '--vc': vc }}>
        <div className="cpa-badge" style={{ '--vc': vc }}>
          <b>{label}</b>{esito?.sub ? <span>{esito.sub}</span> : null}
        </div>
      </div>
    </div>
  );
}
